import { get } from "lodash";
import { useEffect } from "react";
import { useQuery } from "shared/hooks/useApi";
import { TRACKING_CONFIG } from "utils/api/graphql/queries/connectors";

const injectGtag = (googleAdsId) => {
  if (!document.querySelector(`script[data-gtag-id="${googleAdsId}"]`)) {
    const script = document.createElement("script");
    script.src = `https://www.googletagmanager.com/gtag/js?id=${googleAdsId}`;
    script.async = true;
    script.setAttribute("data-gtag-id", googleAdsId);
    document.head.appendChild(script);
  }
  if (!document.querySelector("script[data-gtag-inline='true']")) {
    const inlineScript = document.createElement("script");
    inlineScript.setAttribute("data-gtag-inline", "true");
    inlineScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      window.gtag = gtag;
      gtag('js', new Date());
      gtag('config', '${googleAdsId}');
    `;
    document.head.appendChild(inlineScript);
  }
};

const injectTagManager = (gtmContainerId) => {
  if (
    !document.querySelector(`script[data-gtm-container="${gtmContainerId}"]`)
  ) {
    const gtmScript = document.createElement("script");
    gtmScript.setAttribute("data-gtm-container", gtmContainerId);
    gtmScript.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${gtmContainerId}');`;
    document.head.appendChild(gtmScript);
  }
  if (
    document.body &&
    !document.querySelector(`noscript[data-gtm-container="${gtmContainerId}"]`)
  ) {
    const noscript = document.createElement("noscript");
    noscript.setAttribute("data-gtm-container", gtmContainerId);
    noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmContainerId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    document.body.insertBefore(noscript, document.body.firstChild);
  }
};

const useGoogleTracking = ({ enabled }) => {
  const { data } = useQuery(TRACKING_CONFIG, { skip: !enabled });
  const trackingConfig = enabled ? get(data, "trackingConfig") : null;
  const googleAdsId = get(trackingConfig, "googleAdsId");
  const gtmContainerId = get(trackingConfig, "gtmContainerId");

  useEffect(() => {
    if (googleAdsId) injectGtag(googleAdsId);
    if (gtmContainerId) injectTagManager(gtmContainerId);
  }, [googleAdsId, gtmContainerId]);

  return trackingConfig;
};

export default useGoogleTracking;
